import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://hockey-ready.impultienda.ar/checkout';

/**
 * Carries the visit's UTMs and click IDs (fbclid, gclid…) to the checkout so
 * Impultienda / Meta / Utmify can attribute the sale to the ad.
 */
export function withTrackingParams(url: string): string {
  if (typeof window === 'undefined' || url.startsWith('#')) return url;
  try {
    const target = new URL(url);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (!target.searchParams.has(key)) target.searchParams.set(key, value);
    });
    return target.toString();
  } catch {
    return url;
  }
}
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get HOCKEY READY™ Now',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const [resolvedHref, setResolvedHref] = useState(href);
  useEffect(() => setResolvedHref(withTrackingParams(href)), [href]);
  return <a href={resolvedHref} onClick={e => {
    const finalHref = withTrackingParams(href);
    if (finalHref !== e.currentTarget.href && !href.startsWith('#')) e.currentTarget.href = finalHref;
  }} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-red-700 px-5 py-4 text-center text-sm font-semibold text-white shadow-lg shadow-red-700/30 transition-[transform,background-color] duration-150 ease-out hover:bg-red-800 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/30 sm:px-9 sm:py-5 sm:text-base ${className}`} data-id="element-66" data-mp="35yqrl5lvkb0v">
      <span data-id="element-67" data-mp="1jpuudy1kmuc">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-68" data-mp="6i15us02p3e5" />
    </a>;
}